import React from 'react';
import './CartPage.css';

const CartPage: React.FC = () => {
  return (
    <div className="cart-page">
      <h1>Giỏ Hàng</h1>
      <p>Trang giỏ hàng đang được phát triển...</p>
      <p>Tính năng sẽ bao gồm: Danh sách sản phẩm trong giỏ, Cập nhật số lượng, Thanh toán</p>
    </div>
  );
};

export default CartPage;
